import { render, staticRenderFns } from "./QcStatus.vue?vue&type=template&id=1c0196c1&scoped=true"
import script from "./QcStatus.vue?vue&type=script&lang=js"
export * from "./QcStatus.vue?vue&type=script&lang=js"
import style0 from "./QcStatus.vue?vue&type=style&index=0&id=1c0196c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0196c1",
  null
  
)

export default component.exports